'use client';

import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';

import type { SlotProps } from '../Base/Slot';
import { Slot } from '../Base/Slot';
import { useBasketLink } from '../../shared/useBasketLink';

/** Cart slot */
export const BasketSlot = (props: Pick<SlotProps, 'priority'>) => {
  const { language } = useI18n();
  const { href, label, badgeCount } = useBasketLink();

  return (
    <Slot
      {...props}
      language={language}
      useRouterLink={false}
      icon={<span className="icon-emp-cart size-4" />}
      linkAriaLabel={label}
      href={href}
      badgeCount={badgeCount}
      title={label}
      sx={{ minWidth: { xl: '3rem' } }}
    />
  );
};
